import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../main.css';
import umalusi from '../umalusi.png';

function PrimaryBottomNav() {
  return (
    <Navbar className="custom-bottom-nav flex-column">
      <Container className="d-flex justify-content-around align-items-start flex-wrap w-100">

        {/* Spacer on the left */}
        <div style={{ flex: 1 }}></div>

        {/* Navigation Links - aligned left with margin */}
        <div className="d-flex flex-column align-items-start" style={{ flex: 1, marginLeft: '2rem' }}>
          <h5 className="mb-3 text-white">Navigation</h5>
          <Nav className="flex-column mb-3">
            <Nav.Link as={Link} to="/academics" className="mb-2">- ACADEMICS</Nav.Link>
            <Nav.Link as={Link} to="/our-pillars" className="mb-2">- OUR PILLARS</Nav.Link>
            <Nav.Link as={Link} to="/facilities" className="mb-2">- FACILITIES</Nav.Link>
            <Nav.Link as={Link} to="/how-to-pay" className="mb-2">- HOW TO PAY</Nav.Link>
            <Nav.Link as={Link} to="/quick-tour" className="mb-2">- QUICK TOUR</Nav.Link>
          </Nav>
        </div>

        {/* Google Map - smaller, placed above icons */}
        <div className="d-flex flex-column align-items-center" style={{ marginTop: '2rem', width: '300px', height: '200px' }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d381.065929155871!2d30.331591786097228!3d-24.681162554265807!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ec22e100d29f851%3A0x28b466afcd9581ed!2sHighlands%20College%20%26%20Highlands%20High%20School!5e0!3m2!1sen!2sza!4v1753789082301!5m2!1sen!2sza"
            width="300"
            height="600"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Highlands College Map"
          />
          {/* Contact Icons BELOW map */}
          <div className="footer-text d-flex gap-3 mt-3">
            <OverlayTrigger placement="top" overlay={<Tooltip>Call: (+27)61 545 4633</Tooltip>}>
              <i className="bi bi-telephone contact-icon text-white"></i>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip>Email: admin@highlandscollege.co.za</Tooltip>}>
              <i className="bi bi-envelope-at contact-icon text-white"></i>
            </OverlayTrigger>

            <OverlayTrigger placement="top" overlay={<Tooltip>WhatsApp: (+27)61 545 4633</Tooltip>}>
              <i className="bi bi-whatsapp contact-icon text-white"></i>
            </OverlayTrigger>
          </div>
        </div>
      </Container>

      {/* Footer Bar: Logo + Copyright */}
      <div className="bottom-footer d-flex align-items-center justify-content-between flex-wrap mt-3 px-3 w-100">
        <img
          src={umalusi}
          alt="Umalusi Accreditation"
          style={{
            height: '50px',
            width: 'auto',
            objectFit: 'contain',
          }}
        />
        <span className="text-white small mx-3 text-center flex-grow-1">
          © 2025 Highlands College. All rights reserved.
        </span>
        {/* Empty div to balance layout */}
        <div style={{ flexBasis: '50px' }}></div>
      </div>
    </Navbar>
  );
}

export default PrimaryBottomNav;
